import React from "react";
import { Helmet } from "react-helmet-async";
import {
  SEO_SITE,
  getLogoUrl,
  getPageUrl,
  getStructuredData,
} from "frontend/Utils/seoConfig";

const SeoHelmet = ({
  page,
  service,
  breadcrumbs = [],
  faqs = [],
  extraSchemas = [],
}) => {
  const pageUrl = getPageUrl(page.path);
  const logoUrl = getLogoUrl();

  const structuredData = getStructuredData({
    pageUrl,
    title: page.title,
    description: page.description,
    service,
    breadcrumbs,
    faqs,
    extraSchemas,
  });

  return (
    <Helmet>
      <title>{page.title}</title>

      <meta name="description" content={page.description} />

      {page.keywords && <meta name="keywords" content={page.keywords} />}

      <meta name="robots" content="index, follow" />
      <meta name="author" content={SEO_SITE.author} />
      <meta name="language" content="en-GB" />
      <meta name="geo.region" content="GB" />

      <link rel="canonical" href={pageUrl} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="en_GB" />
      <meta property="og:site_name" content={SEO_SITE.siteName} />
      <meta property="og:title" content={page.title} />
      <meta property="og:description" content={page.description} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:image" content={logoUrl} />
      <meta
        property="og:image:alt"
        content="Rosemount Financial Solutions logo"
      />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={page.title} />
      <meta name="twitter:description" content={page.description} />
      <meta name="twitter:image" content={logoUrl} />
      <meta
        name="twitter:image:alt"
        content="Rosemount Financial Solutions logo"
      />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default SeoHelmet;
